import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    interview: {},
    interview_id: 0,
    job_id: 0,
    applied_id: 0,
    interview_type: "",
    token: "",
    auth_token: "",
    api_key: "",
    showTimer: false,
    duration: 0,
    has_unlimited_duration: false,
    conditional_unlimited_duration: false,
    questionAmount: 0,
    video_exist: false,
    audio_exist: false,
    signup_confirmation: true,
    has_additional_details: false,
    signup_form_options: {},
    can_request_retake: false,
    theme: "",
    consumed_time: 0,
    reInvited: false,
    unlimitedTime: false,
    feedback_link: "",
    internal: 0,
    proctoring: false,
    codingCopyPasteEnabled: false,
    source: 0,
    timeConsume: null,
    questionTimer: false, // to send the time  taken by the candidate on one question to socket
    checked: false,
    hideG2Feedback: false, //  hide g2 feedback for the candidate l
    recordedId: {}, // recorded id of janus if the candidate switch question and not submit answer
    redirectUrl: null,
    preScreening: "",
    answeredPreScreening: 0,
    hasCodingQues: 0,
    contextCount: 0,
    anouncement: {
        content: "",
        status: "0",
    },
    preQualification: false,
    smartScreeningMarks: 0,
    alreadyApplied: false,
    hideVideo: false,
    hasTypingQuestion: 0,
    shouldBeFullScreen: 0,
    isDownTime: false,
    prescreeningText: "",
    instructions: "",
    disqualifiedFromPrescreening: false,
    idVerification: false,
    verificationTemplate: "",
    verificationStatus: 0,
    hasExcelQuestion: 0,
    showExcelFullScreen: false,
    expiryDate: null,
    interviewStep: 1, //first step will be 1->welcome
    idverificationMode: 0,
    preAnswerData: null,
    errorData: null,
    resizablePanel: false, 
    interviewStartTime: null,
    idVerifiactionForStepperModule: false, 
    screenSideImage: null,
    netWorkError: false, 
    showRetryScreen: false, // to show retry screen when network error occurs
    integrationPartnerError: false
};

const interviewSlice = createSlice({
    name: "interview",
    initialState,
    reducers: {
        setInterviewId: (state, { payload }) => {
            state.interview_id = payload;
        },
        setJobId: (state, { payload }) => {
            state.job_id = payload;
        },
        setAppliedId: (state, { payload }) => {
            state.applied_id = payload;
        },
        setInterviewType: (state, { payload }) => {
            state.interview_type = payload;
        },
        setToken: (state, { payload }) => {
            state.token = payload;
        },
        setAuthToken: (state, { payload }) => {
            state.auth_token = payload;
        },
        setApiKey: (state, { payload }) => {
            state.api_key = payload;
        },
        addInterview: (state, { payload }) => {
            state.interview = payload;
        },
        setShowTimer: (state, { payload }) => {
            state.showTimer = payload;
        },
        setDuration: (state, { payload }) => {
            state.duration = payload;
        },
        setHasUnlimitedDuration: (state, { payload }) => {
            state.has_unlimited_duration = payload;
        },
        setConditionalUnlimitedDuration: (state, { payload }) => {
            state.conditional_unlimited_duration = payload;
        },
        setQuestionAmount: (state, { payload }) => {
            state.questionAmount = payload;
        },
        setVideoExist: (state, { payload }) => {
            state.video_exist = payload;
        },
        setAudioExist: (state, { payload }) => {
            state.audio_exist = payload;
        },
        setSignupConfirmation: (state, { payload }) => {
            state.signup_confirmation = payload;
        },
        setHasAdditionalDetails: (state, { payload }) => {
            state.has_additional_details = payload;
        },
        setSignupFormOptions: (state, { payload }) => {
            state.signup_form_options = payload;
        },
        setCanRequestRetake: (state, { payload }) => {
            state.can_request_retake = payload;
        },
        setInterviewTheme: (state, { payload }) => {
            state.theme = payload;
        },
        setConsumedTime: (state, { payload }) => {
            state.consumed_time = payload;
        },
        setReInvited: (state, { payload }) => {
            state.reInvited = payload;
        },
        setUnlimitedTimer: (state, { payload }) => {
            state.unlimitedTime = payload;
        },
        setFeedbackLink: (state, { payload }) => {
            state.feedback_link = payload;
        },
        setInternal: (state, { payload }) => {
            state.internal = payload;
        },
        setSource: (state, { payload }) => {
            state.source = payload;
        },
        setProctoring: (state, { payload }) => {
            state.proctoring = payload;
        },
        setCodingCopyPasteEnabled: (state, { payload }) => {
            state.codingCopyPasteEnabled = payload;
        },
        setTimeConsume: (state, { payload }) => {
            state.timeConsume = payload;
        },
        setQuestionTimer: (state, { payload }) => {
            state.questionTimer = payload;
        },
        setHideG2Feedback: (state, { payload }) => {
            state.hideG2Feedback = payload;
        },
        setRecordedId: (state, { payload }) => {
            state.recordedId = payload;
        },
        setRedirectUrl: (state, { payload }) => {
            state.redirectUrl = payload;
        },
        setPreScreening: (state, { payload }) => {
            state.preScreening = payload;
        },
        setChecked: (state, { payload }) => {
            state.checked = payload;
        },
        setAnsweredPreScreening: (state, { payload }) => {
            state.answeredPreScreening = payload;
        },
        setHasCodingQues: (state, { payload }) => {
            state.hasCodingQues = payload;
        },
        setContextCount: (state, { payload }) => {
            state.contextCount = payload;
        },
        setAnnouncement: (state, { payload }) => {
            state.anouncement = payload;
        },
        setPreQualification: (state, { payload }) => {
            state.preQualification = payload;
        },
        setSmartScreeningMarks: (state, { payload }) => {
            state.smartScreeningMarks = payload;
        },
        setAlreadyApplied: (state, { payload }) => {
            state.alreadyApplied = payload;
        },
        setHideVideo: (state, { payload }) => {
            state.hideVideo = payload;
        },
        setHasTypingQuestion: (state, { payload }) => {
            state.hasTypingQuestion = payload;
        },
        setShouldBeFullScreen: (state, { payload }) => {
            state.shouldBeFullScreen = payload;
        },
        setIsDownTime: (state, { payload }) => {
            state.isDownTime = payload;
        },
        setPrescreeningText: (state, { payload }) => {
            state.prescreeningText = payload;
        },
        setInstructions: (state, { payload }) => {
            state.instructions = payload || "";
        },
        setDisqualifiedFromPrescreening: (state, { payload }) => {
            state.disqualifiedFromPrescreening = payload;
        },
        setIdVerification: (state, { payload }) => {
            state.idVerification = payload;
        },
        setVerificationTemplate: (state, { payload }) => {
            state.verificationTemplate = payload;
        },
        setVerificationStatus: (state, { payload }) => {
            state.verificationStatus = payload;
        },
        setHasExcelQuestion: (state, { payload }) => {
            state.hasExcelQuestion = payload;
        },
        setShowExcelFullScreen: (state, { payload }) => {
            state.showExcelFullScreen = payload;
        },
        setExpiryDate: (state, { payload }) => {
            state.expiryDate = payload;
        },
        setInterviewStep: (state, { payload }) => {
            state.interviewStep = payload;
        },
        setIdVerificationMode: (state, { payload }) => {
            state.idverificationMode = payload;
        },
        setPreAnswerData: (state, { payload }) => {
            state.preAnswerData = payload;
        },
        setErrorData: (state, { payload }) => {
            state.errorData = payload;
        },
        setResizablePanel: (state) => {
            state.resizablePanel = !state.resizablePanel;
        },
        setInterviewStartTime: (state, { payload }) => {
            state.interviewStartTime = payload;
        },
        setIdVerificationStatusForStepperModule: (state, { payload }) => {
            state.idVerifiactionForStepperModule = payload;
        },
        setScreenSideImage: (state, { payload }) => {
            state.screenSideImage = payload;
        },
        setNetWorkError: (state, { payload }) => {
            state.netWorkError = payload;
        },
        setShowRetryScreen: (state, { payload }) => {
            state.showRetryScreen = payload;
        },
        setIntegrationPartnerError: (state, { payload }) => {
            state.integrationPartnerError = payload;
        }

    },
});

export const {
    addInterview,
    setQuestionTimer,
    setInterviewId,
    setJobId,
    setAppliedId,
    setInterviewType,
    setToken,
    setAuthToken,
    setApiKey,
    setDuration,
    setShowTimer,
    setHasUnlimitedDuration,
    setConditionalUnlimitedDuration,
    setQuestionAmount,
    setVideoExist,
    setProctoring,
    setSource,
    setAudioExist,
    setInternal,
    setSignupConfirmation,
    setHasAdditionalDetails,
    setSignupFormOptions,
    setCanRequestRetake,
    setInterviewTheme,
    setConsumedTime,
    setReInvited,
    setUnlimitedTimer,
    setFeedbackLink,
    setTimeConsume,
    setHideG2Feedback,
    setRecordedId,
    setRedirectUrl,
    setChecked,
    setPreScreening,
    setAnsweredPreScreening,
    setHasCodingQues,
    setContextCount,
    setAnnouncement,
    setPreQualification,
    setSmartScreeningMarks,
    setAlreadyApplied,
    setHideVideo,
    setHasTypingQuestion,
    setCodingCopyPasteEnabled,
    setShouldBeFullScreen,
    setIsDownTime,
    setPrescreeningText,
    setInstructions,
    setDisqualifiedFromPrescreening,
    setIdVerification,
    setVerificationTemplate,
    setVerificationStatus,
    setHasExcelQuestion,
    setShowExcelFullScreen,
    setExpiryDate,
    setInterviewStep,
    setIdVerificationMode,
    setPreAnswerData,
    setErrorData,
    setResizablePanel,
    setInterviewStartTime,
    setIdVerificationStatusForStepperModule,
    setScreenSideImage, 
    setNetWorkError,
    setShowRetryScreen,
    setIntegrationPartnerError
} = interviewSlice.actions;

export const getInterview = (state) => state.interview.interview;
export const getJobId = (state) => state.interview.job_id;
export const getAppliedId = (state) => state.interview.applied_id;
export const getInterviewType = (state) => state.interview.interview_type;
export const getInterviewId = (state) => state.interview.interview_id;
export const getToken = (state) => state.interview.token;
export const getAuthToken = (state) => state.interview.auth_token;
export const getApiKey = (state) => state.interview.api_key;
export const getShowTimer = (state) => state.interview.showTimer;
export const getTimerDuration = (state) => state.interview.timerDuration;
export const getDuration = (state) => state.interview.duration;
export const getHasUnlimitedDuration = (state) => state.interview.has_unlimited_duration;
export const getConditionalUnlimitedDuration = (state) => state.interview.conditional_unlimited_duration;
export const getQuestionAmount = (state) => state.interview.questionAmount;
export const getVideoExist = (state) => state.interview.video_exist;
export const getAudioExist = (state) => state.interview.audio_exist;
export const getSignupConfirmation = (state) => state.interview.signup_confirmation;
export const getHasAdditionalDetails = (state) => state.interview.has_additional_details;
export const getSignupFormOptions = (state) => state.interview.signup_form_options;
export const getCanRequestRetake = (state) => state.interview.can_request_retake;
export const getInterviewThemeFromStore = (state) => state.interview.theme;
export const getConsumedTime = (state) => state.interview.consumed_time;
export const getReInvited = (state) => state.interview.reInvited;
export const getUnlimitedTimer = (state) => state.interview.unlimitedTime;
export const getFeedbackLink = (state) => state.interview.feedback_link;
export const getInternal = (state) => state.interview?.internal;
export const getSource = (state) => state.interview.source;
export const getProctoring = (state) => state.interview.proctoring;
export const getCodingCopyPasteEnabled = (state) => state.interview.codingCopyPasteEnabled;
export const getTimeConsume = (state) => state.interview.timeConsume;
export const getQuestionTimer = (state) => state.interview.questionTimer;
export const getChecked = (state) => state.interview.checked;
export const getHideG2Feedback = (state) => state.interview.hideG2Feedback;
export const getRecordedId = (state) => state.interview.recordedId;
export const getRedirectUrl = (state) => state.interview.redirectUrl;
export const getPreScreening = (state) => state.interview.preScreening;
export const getAnsweredPreScreening = (state) => state.interview.answeredPreScreening;
export const getHasCodingQues = (state) => state.interview.hasCodingQues;
export const getContextCount = (state) => state.interview.contextCount;
export const getAnnouncement = (state) => state.interview.anouncement;
export const getPreQualification = (state) => state.interview.preQualification;
export const getSmartScreeningMarks = (state) => state.interview.smartScreeningMarks;
export const getAlreadyApplied = (state) => state.interview.alreadyApplied;
export const getHIdeVideo = (state) => state.interview.hideVideo;
export const getHasTypingQuestion = (state) => state.interview.hasTypingQuestion;
export const getShouldBeFullScreen = (state) => state.interview.shouldBeFullScreen;
export const getIsDownTime = (state) => state.interview.isDownTime;
export const getPrescreeningText = (state) => state.interview.prescreeningText;
export const getInstructions = (state) => state.interview.instructions;
export const getDisqualifiedFromPrescreening = (state) => state.interview.disqualifiedFromPrescreening;
export const getIdVerification = (state) => state.interview.idVerification;
export const getVerificationTemplate = (state) => state.interview.verificationTemplate;
export const getVerificationStatus = (state) => state.interview.verificationStatus;
export const getHasExcelQuestion = (state) => state.interview.hasExcelQuestion;
export const getShowExcelFullScreen = (state) => state.interview.showExcelFullScreen;
export const getExpiryDate = (state) => state.interview.expiryDate;
export const getInterviewStep = (state) => state.interview.interviewStep;
export const getIdVerificationMode = (state) => state.interview.idverificationMode;
export const getPreAnswerData = (state) => state.interview.preAnswerData;
export const getErrorData = (state) => state.interview.errorData;
export const getResizablePanel = (state) => state.interview.resizablePanel;
export const getInterviewStartTime = (state) => state.interview.interviewStartTime;
export const getIdVerificationStatusForStepperModule = (state) => state.interview.idVerifiactionForStepperModule;
export const getScreenSideImage = (state) => state.interview.screenSideImage
export const getNetworkError = (state) => state.interview.netWorkError
export const getShowRetryScreen = (state) => state.interview.showRetryScreen
export const getIntegrationPartnerError = (state) => state.interview.integrationPartnerError

export default interviewSlice.reducer;
